import { ChargebackReason } from 'commons/types';

const DEFENSE_MODEL_URLS: Record<ChargebackReason, string> = {
  [ChargebackReason.Fraud]:
    'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/7634/direct/1780409856040/fraude.pdf',
  [ChargebackReason.Dispute]:
    'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/7634/direct/1780411606040/desacordo-comercial.pdf',
  [ChargebackReason.DuplicateProcessing]:
    'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/7634/direct/1780411647928/erro-de-processamento.pdf',
  [ChargebackReason.Authorization]:
    'https://static.helpjuice.com/helpjuice_production/uploads/upload/image/7634/direct/1780411622735/autorizacao.pdf',
};

export function getDefenseModelUrl(reason: ChargebackReason): string {
  return (
    DEFENSE_MODEL_URLS[reason] ?? DEFENSE_MODEL_URLS[ChargebackReason.Fraud]
  );
}
